
/**
 * Lechia Currency Converter
 */

let LechiaCurrency = {
    
    /**
     * Get the converted amount display
     * @param {*} amount 
     * @returns {string}
     */
    getConvertedDisplay(amount) {
        let convertedAmount = this.getConvertedAmount(amount);
        return new Intl.NumberFormat(getNavigatorLanguage(), { style: 'currency', currency: convertedAmount.currency, currencyDisplay: 'narrowSymbol'}).format(convertedAmount.amount);
    },
    /**
     * Get an unconverted amount display
     * @param {*} amount 
     * @param {*} options 
     * @returns {string}
     */
    getAmountDisplay(amount, options) {
        return new Intl.NumberFormat(getNavigatorLanguage(), {...{ style: 'currency', currency: getCookie('cart_currency'), currencyDisplay: 'narrowSymbol'}, ...options }).format(amount);
    },
    /**
     * Get the converted amount
     * @param {*} amount
     * @returns object
     * 
     * @example
     * LechiaCurrency.getConvertedAmount(100);
     * // {
     * //     amount: 100,
     * //     currency: 'USD'
     * // }
     **/
    getConvertedAmount(amount) {
        let cartCurrency = getCookie('cart_currency');
        let convertedCents = Number((Number(amount) * Shopify.currency.rate).toFixed(0));
        let convertedAmount = convertedCents/100;
        return {
            currency: cartCurrency,
            cents: convertedCents,
            amount: convertedAmount
        };
    }
}